import React from 'react';
import { ContentSection } from '../ui/ContentSection';
import { motion } from 'framer-motion';
interface NarrativeBlockProps {
  label: string;
  title: string;
  children: ReactNode;
  background?: 'white' | 'gray';
  highlight?: boolean;
  image?: string;
  imageAlt?: string;
  imagePosition?: 'left' | 'right';
}
export function NarrativeBlock({
  label,
  title,
  children,
  background = 'white',
  highlight = false,
  image,
  imageAlt = '',
  imagePosition = 'right'
}: NarrativeBlockProps) {
  return <ContentSection background={background} data-id="element-88">
      {image ? <div className={`grid md:grid-cols-2 gap-12 items-center ${imagePosition === 'left' ? 'md:flex-row-reverse' : ''}`} data-id="element-89">
          <div className={`${imagePosition === 'left' ? 'md:order-2' : ''}`} data-id="element-90">
            <span className="text-amber-600 font-bold tracking-wider text-sm uppercase mb-4 block" data-id="element-91">
              {label}
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-[#1A1A1A] mb-8 leading-tight" data-id="element-92">
              {title}
            </h2>
            <div className={`
              prose prose-lg md:prose-xl max-w-none text-gray-600 leading-relaxed
              ${highlight ? 'border-l-4 border-amber-500 pl-6' : ''}
            `} data-id="element-93">
              {children}
            </div>
          </div>
          <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className={`${imagePosition === 'left' ? 'md:order-1' : ''}`} data-id="element-94">
            <img src={image} alt={imageAlt} className="w-full h-auto rounded-2xl shadow-xl" data-id="element-95" />
          </motion.div>
        </div> : <div className="flex flex-col md:items-center md:text-center" data-id="element-96">
          <span className="text-amber-600 font-bold tracking-wider text-sm uppercase mb-4" data-id="element-97">
            {label}
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#1A1A1A] mb-8 leading-tight" data-id="element-98">
            {title}
          </h2>
          <div className={`
            prose prose-lg md:prose-xl max-w-none text-gray-600 leading-relaxed
            ${highlight ? 'border-l-4 border-amber-500 pl-6 md:border-none md:pl-0' : ''}
          `} data-id="element-99">
            {children}
          </div>
        </div>}
    </ContentSection>;
}